import React from "react";

interface QuestionComponentProps {
  questionNumber: number;
  questionText: string;
  name: string;
  formik: any;
  value: string;
}

const QuestionComponent = ({
  questionNumber,
  questionText,
  name,
  value,
  formik,
}: QuestionComponentProps) => {
  return (
    <div
      className={questionNumber % 2 !== 0 ? "question-odd" : "question-even"}
    >
      <div className="row question-height">
        <div className="col-1 question-alignment question-padding question-number">
          {questionNumber}
        </div>
        <div className="col-8 question-alignment question-padding question-text">
          {questionText}
        </div>
        <div className="col-3 question-padding radio-spacing">
          <input
            type="radio"
            name={name}
            style={{ width: "16px", accentColor: "#004A96" }}
            value="disagree"
            checked={value === "disagree"}
            onChange={formik.handleChange}
          ></input>
          <input
            type="radio"
            name={name}
            style={{ width: "16px", accentColor: "#004A96" }}
            value="neutral"
            checked={value === "neutral"}
            onChange={formik.handleChange}
          ></input>
          <input
            type="radio"
            name={name}
            style={{ width: "16px", accentColor: "#004A96" }}
            value="agree"
            checked={value === "agree"}
            onChange={formik.handleChange}
          ></input>
        </div>
      </div>
    </div>
  );
};

export default QuestionComponent;
